var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#7A7A7A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13v-8a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a2 2 0 0 0 6 0v-8a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a8 8 0 0 1 -16 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8l5 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8l4 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnetIcon);
export default __webpack_public_path__ + "static/media/magnetIcon.c443709ba49f73491b9079060e69e031.svg";
export { ForwardRef as ReactComponent };